import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Languages } from "lucide-react";

const LANGS = [["en", "English", "EN"], ["hi", "हिंदी", "हि"], ["or", "ଓଡ଼ିଆ", "ଓ"], ["bn", "বাংলা", "বা"], ["ta", "தமிழ்", "த"], ["te", "తెలుగు", "తె"],
  ["kn", "ಕನ್ನಡ", "ಕ"], ["ml", "മലയാളം", "മ"], ["mr", "मराठी", "म"], ["gu", "ગુજરાતી", "ગુ"], ["pa", "ਪੰਜਾਬੀ", "ਪ"], ["ur", "اردو", "ار"], ["as", "অসমীয়া", "অ"]];

const current = () => (document.cookie.match(/googtrans=\/en\/([a-z-]+)/) || [])[1] || "en";

const setCookie = (v) => {
  const parts = window.location.hostname.split(".");
  const domains = [""];
  for (let i = 0; i < parts.length - 1; i += 1) {
    const d = parts.slice(i).join(".");
    domains.push(`; domain=${d}`, `; domain=.${d}`);
  }
  const exp = v ? "" : "; expires=Thu, 01 Jan 1970 00:00:00 GMT";
  domains.forEach((d) => {
    document.cookie = `googtrans=${v || ""}; path=/${d}${exp}`;
  });
};

// Google Translate changes text nodes; keep React from crashing when it removes/inserts them.
const patchDom = () => {
  if (Node.prototype.__bgPatched) return;
  Node.prototype.__bgPatched = true;
  const remove = Node.prototype.removeChild;
  Node.prototype.removeChild = function (child) {
    if (child.parentNode !== this) return child;
    return remove.call(this, child);
  };
  const insert = Node.prototype.insertBefore;
  Node.prototype.insertBefore = function (node, ref) {
    if (ref && ref.parentNode !== this) return node;
    return insert.call(this, node, ref);
  };
};

export const LanguageToggle = () => {
  const lang = current();
  const [open, setOpen] = useState(false);
  const admin = useLocation().pathname.startsWith("/bg-admin-portal");
  useEffect(() => {
    document.body.classList.toggle("notranslate", admin);
  }, [admin]);
  useEffect(() => {
    if (admin || lang === "en" || document.getElementById("gt-script")) return;
    patchDom();
    window.googleTranslateElementInit = () => {
      new window.google.translate.TranslateElement({ pageLanguage: "en", includedLanguages: LANGS.map((l) => l[0]).join(","), autoDisplay: false }, "google_translate_element");
    };
    const s = document.createElement("script");
    s.id = "gt-script";
    s.src = "https://translate.google.com/translate_a/element.js?cb=googleTranslateElementInit";
    document.body.appendChild(s);
  }, [lang, admin]);
  const choose = (code) => {
    setOpen(false);
    if (code === lang) return;
    setCookie(code === "en" ? null : `/en/${code}`);
    window.location.reload();
  };
  if (admin) return null;
  const cur = LANGS.find((l) => l[0] === lang) || LANGS[0];
  return (
    <>
      <div id="google_translate_element" />
      <div translate="no" className="notranslate fixed bottom-[9.5rem] right-3 z-[60]">
        {open && (
          <div data-testid="language-menu" className="absolute bottom-full right-0 mb-2 max-h-[60vh] w-40 overflow-y-auto rounded-xl bg-white py-1 shadow-xl ring-1 ring-slate-200">
            {LANGS.map(([code, name]) => (
              <button key={code} onClick={() => choose(code)} data-testid={`language-option-${code}`}
                className={`block w-full px-3 py-1.5 text-left text-sm hover:bg-orange-50 ${code === lang ? "font-bold text-orange-600" : "text-slate-700"}`}>{name}</button>
            ))}
          </div>
        )}
        <button onClick={() => setOpen((o) => !o)} data-testid="language-toggle" aria-label="Change language"
          className="keep-dark flex h-9 items-center gap-1 rounded-full px-2.5 text-xs font-bold text-white shadow-lg ring-1 ring-white/20 hover:opacity-90">
          <Languages className="h-4 w-4" />{cur[2]}
        </button>
      </div>
    </>
  );
};
